import { render, staticRenderFns } from "./AccessCreatorChangePopup.vue?vue&type=template&id=bfbc06ec"
import script from "./AccessCreatorChangePopup.vue?vue&type=script&lang=js"
export * from "./AccessCreatorChangePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports